export default "__VITE_ASSET__B8pkQEj2__"